module.exports = __webpack_public_path__ + "img/unicall-logo.8617aa83.svg";